var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2872",
    "data-name": "Rectangle 2872",
    width: 24,
    height: 24,
    transform: "translate(0.043)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27229",
    "data-name": "Group 27229",
    transform: "translate(-0.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27228",
    "data-name": "Group 27228",
    transform: "translate(0.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37818",
    "data-name": "Path 37818",
    d: "M19.4,19.793a.9.9,0,0,1-.9-.9V4.657a.9.9,0,0,1,1.8,0V18.893a.9.9,0,0,1-.9.9",
    transform: "translate(-7.9 -1.503)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37819",
    "data-name": "Path 37819",
    d: "M21.8,34.469H7.4a.9.9,0,1,1,0-1.8H21.8a.9.9,0,1,1,0,1.8",
    transform: "translate(-3.1 -13.068)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37820",
    "data-name": "Path 37820",
    d: "M16.006,25.89a.9.9,0,0,1-.637-.263l-5.091-5.092a.9.9,0,0,1,1.273-1.273l4.455,4.455,4.455-4.455a.9.9,0,0,1,1.273,1.273l-5.091,5.092a.9.9,0,0,1-.637.263",
    transform: "translate(-4.506 -7.6)",
    fill: "#fc3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.c0afc1a2ac7f7467ab79924cf08e9cad.svg";
export { ForwardRef as ReactComponent };